export type AuthMode = "header" | "cookie";

// set in .env.development / .env.production
export const AUTH_MODE: AuthMode =
  process.env.REACT_APP_AUTH_MODE === "header" ? "header" : "cookie";

export const REACT_APP_API_URL: string = process.env.REACT_APP_API_URL || "";

// backend login route, takes ?return_url=
export const LOGIN_PATH: string =
  process.env.REACT_APP_LOGIN_PATH || "azure/login";

// full login url, for when the API goes through a proxy
export const LOGIN_URL: string = process.env.REACT_APP_LOGIN_URL || "";
